var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    style: {
      background: "#0f172a"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 650)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 400h100v-300h50v250h80v-200h60v150h70v-350h90v300h100v-250h120v400h100v-300h150v350h120v-200h80v250h100v-150h60v200h90v-300h100v400H0z",
    fill: "#7dd3fc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#38bdf8",
    strokeWidth: 2,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 400,
    r: 15,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 15,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 350,
    r: 15,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1600,
    cy: 450,
    r: 15,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 400q175-50 500 100t800-50",
    strokeDasharray: "8 8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960 540)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    r: 200,
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-200",
    stroke: "#f59e0b",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-200",
    stroke: "#10b981",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-200",
    stroke: "#f59e0b",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("circle", {
    r: 50,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30-30l60 60m-60 0l60-60",
    stroke: "#38bdf8",
    strokeWidth: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#38bdf8",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 200,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 800,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 900,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 100,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(45)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f59e0b",
    strokeWidth: 2,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 800q100-150 300-50t200 200",
    fill: "none",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400 200q-150 100-200 300t150 250",
    fill: "none",
    strokeDasharray: "8 8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.5721baba04a610a59486e70d71006de7.svg";
export { ForwardRef as ReactComponent };